import Box from '@mui/material/Box';

import { useModalStore } from '@/components/modal/modal.store';

export function AgreementsReadMoreModal() {
  const { additionalContent } = useModalStore();

  return (
    <>
      {additionalContent ? <Box data-testid="agreements-read-more">{additionalContent}</Box> : null}
    </>
  );
}
